import React from "react";

const REACT_APP_PRIMARY_COLOR   = "#" + sessionStorage.getItem('company_primary_color');
const REACT_APP_SECONDARY_COLOR = "#" + sessionStorage.getItem('company_secondary_color');

export const Colors = {
    search_button_bg: "#408fd2",  // blue
    ok_button_bg : "#408fd2",  // blue
    add_button_bg : "#999",  // blue
    default_blue : "#408fd2",  // blue
    cancel_button_bg: "#999",
    delete_button_bg: "#ff4444", // darker: #CC0000
    delete_button_dark_red_bg: "#CC0000",
    dark_gray: "#666",
    medium_gray: "#999", // used as list subheader button; ie "programs list > add folder"
    light_gray: "#ccc",

    ////  COMPANY COLORS  ////
    primary_color: REACT_APP_PRIMARY_COLOR, // "#d23720", // accelerate sports perf color
    //primary_color: "#a3de35", // training slate color

    secondary_color: REACT_APP_SECONDARY_COLOR //"#f87e72" // sidenavbar week color
}



// WEBPACK FOOTER //
// ./src/utils/Colors.js